import React, { useEffect } from "react"

import { PreviewFeaturesFooterItem } from "./PreviewFeaturesFooterItem"
import { useAppDispatch, useAppSelector } from "../../../hooks"
import { fetchPreviewFeatures } from "../slice"

interface Props {
    snippetContent: string
    arePreviewFeaturesEnabled: boolean
    versionSnippet?: string
}

export default function Footer(props: Props): JSX.Element {
    const { previewFeatures, isLoading } = useAppSelector(
        (state) => state.footer,
    )

    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(fetchPreviewFeatures())
    }, [])

    const { snippetContent, versionSnippet } = props

    return (
        <>
            <footer className="tw-flex tw-items-center tw-justify-center tw-py-2 tw-px-4 text-white">
                <div className="tw-flex tw-items-center tw-justify-start tw-flex-1">
                    {versionSnippet && (
                        <div
                            className="label is-dimmed"
                            dangerouslySetInnerHTML={{ __html: versionSnippet }}
                        />
                    )}

                    {props.arePreviewFeaturesEnabled && (
                        <>
                            <div className="tw-mx-2">·</div>

                            <PreviewFeaturesFooterItem
                                features={previewFeatures}
                                isLoading={isLoading}
                            />
                        </>
                    )}
                </div>

                <div
                    className="tw-flex"
                    dangerouslySetInnerHTML={{
                        __html: snippetContent || "",
                    }}
                />
            </footer>
        </>
    )
}
